import React, { useState } from 'react';
import { withGoogleMap, GoogleMap, Polygon, Marker, InfoWindow } from 'react-google-maps';
import withScriptjs from 'react-google-maps/lib/withScriptjs';

const googleMapURL = `https://maps.googleapis.com/maps/api/js?libraries=geometry&key=${process.env.REACT_APP_GOOGLE_MAP_WEBSITE_KEY}`;

const MapWithAMarker = withScriptjs(withGoogleMap(props => {
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [pharmacyTooltipId, setPharmacyTooltipId] = useState(null);
  const {
    pharmacies = [], withMarker = false, withPaidDeliverySplit = false,
    onClickPolygon, onClickMarker,
  } = props;
  const mapItems = [];

  const handleMouseOver = pharmacyId => {
    setPharmacyTooltipId(pharmacyId);
    setShowInfoWindow(true);
  };
  const handleMouseExit = () => {
    setPharmacyTooltipId(null);
    setShowInfoWindow(false);
  };

  pharmacies.forEach((pharmacy, i) => {
    const { delivery_partner, paid_delivery, location, _id } = pharmacy || {};
    const referralPharmacy = delivery_partner ? delivery_partner.rx_referral_commission : false;
    const enabledColor = withPaidDeliverySplit && paid_delivery ? '#294d9d' : '#2f9d6d';

    mapItems.push(
      <Polygon
        key={`${i}-polygon`}
        defaultOptions={{
          strokeColor: referralPharmacy ? enabledColor : '#D3D3D3',
          fillOpacity: referralPharmacy ? 0.35 : 0.10,
        }}
        onClick={() => onClickPolygon(_id)}
        paths={pharmacy.paths}
      />
    );

    if (withMarker && location && location.coordinates) {
      mapItems.push(
        <Marker
          key={`${i}-marker`}
          onMouseOver={() => handleMouseOver(_id)}
          onMouseOut={() => handleMouseExit()}
          onClick={() => onClickMarker(_id)}
          position={{ lng: location.coordinates[0], lat: location.coordinates[1] }}
          draggable={false}
        >
          {showInfoWindow && (pharmacyTooltipId === _id) && (
            <InfoWindow>
              <h4>{pharmacy.pharmacy_name}</h4>
            </InfoWindow>
          )}
        </Marker>
      );
    }
  });

  return (
    <GoogleMap defaultZoom={8} defaultCenter={props.defaultCenter}>
      {mapItems}
    </GoogleMap>
  );
}));

const GeozonesMap = (props) => {
  let pharmacies = [];

  if (props.pharmacies?.length) {
    pharmacies = props.pharmacies.map(pharmacy => {
      const paths = pharmacy.delivery && pharmacy.delivery.geofence && pharmacy.delivery.geofence.coordinates
        ? pharmacy.delivery.geofence.coordinates[0].map(latLng => ({ lng: latLng[0], lat: latLng[1] })).slice(0, -1)
        : [];

      return { ...pharmacy, paths };
    })
  }

  return (
    <MapWithAMarker
      googleMapURL={googleMapURL}
      pharmacies={pharmacies}
      withMarker={props.withMarker}
      withPaidDeliverySplit={props.withPaidDeliverySplit}
      onClickPolygon={props.onClickPolygon}
      onClickMarker={props.onClickMarker}
      defaultCenter={{ lat: 52.33483030630544, lng: 0.03598141870111249 }}
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height: `600px` }} />}
      mapElement={<div style={{ height: `100%` }} />}
    />
  );
};

GeozonesMap.defaultProps = {
  withMarker: false,
  withPaidDeliverySplit: false,
  onClickPolygon: () => { },
  onClickMarker: () => { },
};

export default GeozonesMap;
